import App from './application-container';
import { LOG, display_message_to_user } from '@phi/logging/frontend';
import { Fallthrough, is_modifier, key_to_number } from './keyboard';
import {
    find_camera_target_point_from_mouse_location,
    set_camera_rotation_around_target_point,
} from './utility';

let keypress_blocked = false;

export function set_shift(x: boolean): void { App.state.shift_is_pressed = x; }

export function set_control(x: boolean): void {
    App.state.ctrl_is_pressed = x;
    if (x) App.state.panning = true;
}

export function set_alt(x: boolean): void { App.state.alt_is_pressed = x; }

export function set_gui(x: boolean): void { App.state.command_is_pressed = x; }

export function shift_pressed(): boolean { return App.state.shift_is_pressed; }

export function alt_pressed(): boolean { return App.state.alt_is_pressed; }

export function ctrl_pressed(): boolean { return App.state.ctrl_is_pressed; }

export function gui_pressed(): boolean { return App.state.command_is_pressed; }

export function declutch_me(): void { keypress_blocked = false; }

export function clutch_me() {
    setTimeout(() => declutch_me(), 100);
    if (keypress_blocked) {
        console.log('I am still clutched');
        return;
    }
    keypress_blocked = true;
}

export function on_key_down(event: KeyboardEvent) {
    // Declutch keypresses unless it's a modifier key
    if (!is_modifier(event.key))
        clutch_me();

    const num = key_to_number(event);
    const f = App.state.keymap.down.get(num) || App.state.keymap.down.get(Fallthrough);
    if (f)
        return f(event);
    else
        display_message_to_user(
            LOG.INFO,
            'You pressed an unrecognized key.',
        );
}

export function on_key_up(event: KeyboardEvent) {
    App.state.panning = false;
    App.state.rotating = false;
    set_control(false);
    const num = key_to_number(event);
    const f = App.state.keymap.up.get(num) || App.state.keymap.up.get(Fallthrough);
    if (f) return f(event);
}

export function handle_right_click(e: MouseEvent) {
    const camera_target_point = find_camera_target_point_from_mouse_location(uid_camera);
    if (camera_target_point)
        set_camera_rotation_around_target_point(camera_target_point);
}
